var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2657 6.40084C11.2657 9.00887 9.12264 11.1231 6.47899 11.1231C3.83534 11.1231 1.69224 9.00887 1.69224 6.40084C1.69224 3.7928 3.83534 1.67857 6.47899 1.67857C9.12264 1.67857 11.2657 3.7928 11.2657 6.40084ZM0.666504 6.40084C0.666504 9.56774 3.26884 12.135 6.47899 12.135C7.84134 12.135 9.09422 11.6726 10.0852 10.8983L14.2771 15.2297C14.4714 15.4305 14.7939 15.4335 14.9973 15.2365C15.2008 15.0394 15.2082 14.7168 15.0139 14.5161L10.8347 10.1978C11.7413 9.18646 12.2915 7.85704 12.2915 6.40084C12.2915 3.23394 9.68914 0.666656 6.47899 0.666656C3.26884 0.666656 0.666504 3.23394 0.666504 6.40084Z",
    fill: "#1F2532"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_10791",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2657 6.40084C11.2657 9.00887 9.12264 11.1231 6.47899 11.1231C3.83534 11.1231 1.69224 9.00887 1.69224 6.40084C1.69224 3.7928 3.83534 1.67857 6.47899 1.67857C9.12264 1.67857 11.2657 3.7928 11.2657 6.40084ZM0.666504 6.40084C0.666504 9.56774 3.26884 12.135 6.47899 12.135C7.84134 12.135 9.09422 11.6726 10.0852 10.8983L14.2771 15.2297C14.4714 15.4305 14.7939 15.4335 14.9973 15.2365C15.2008 15.0394 15.2082 14.7168 15.0139 14.5161L10.8347 10.1978C11.7413 9.18646 12.2915 7.85704 12.2915 6.40084C12.2915 3.23394 9.68914 0.666656 6.47899 0.666656C3.26884 0.666656 0.666504 3.23394 0.666504 6.40084Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_10791)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.921951825d7110bd5a6a1936f7f4eb61.svg";
export { ForwardRef as ReactComponent };